import { useEffect } from "react";
import type { ApolloError } from "@apollo/client";
import { useSupabaseAuth } from "@ugg/shared/components/auth/SupabaseAuthProvider";
import { useUserStateQuery } from "@ugitgud/legos/queries/lol";
import { useCreateSupabaseAccountMutation } from "@ugitgud/legos/queries/auth";

const getErrorCode = (error: unknown) => (error as ApolloError)?.graphQLErrors?.[0]?.message;

export function useSupabaseAccount() {
  const { status } = useSupabaseAuth();
  const signedIn = status === "signed-in";
  const { data, loading, error } = useUserStateQuery({ skip: !signedIn });
  const hasAccount = signedIn && !!data?.getState;
  const needsAccount = signedIn && !loading && getErrorCode(error) === "account_required";

  return { hasAccount, needsAccount, isResolving: status === "loading" || (signedIn && loading) };
}

export function useAutoCreateSupabaseAccount(skip = false) {
  const { needsAccount } = useSupabaseAccount();
  const [createSupabaseAccount] = useCreateSupabaseAccountMutation({ refetchQueries: "active" });

  useEffect(() => {
    if (needsAccount && !skip) createSupabaseAccount().catch(console.error);
  }, [needsAccount, skip]);
}
